import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';

import styles from './AnimationTransparentView.module.scss';
function AnimationTransparentViewComponent() {
  const { animationStore } = useStores();

  if (!animationStore.animationBlockScreenVisible) {
    return null;
  }

  return <div className={styles.container} />;
}

export const AnimationTransparentView = observer(AnimationTransparentViewComponent);
